<div class="time-range-picker-container displayFlexSpaceBetween align-item-center" 
[ngClass]="{active: isOpen}" 
(click)="openPicker()"
cdkOverlayOrigin 
#trigger="cdkOverlayOrigin">
    <div class="selected-time-range color-181F33">
        {{
        (timeRangeControl?.value?.startTime | twelvehourtimeformatter)
        + ' to ' + 
        (timeRangeControl?.value?.endTime | twelvehourtimeformatter)
        }}
    </div>
    <div class="caret" [ngClass]="{active: isOpen}">
        <img src="assets/caret-down-large.svg" alt="caret">
    </div>
    
    <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="closePicker()"    
    >
    <div class="time-range-box">
        <div class="time-input displayFlexSpaceBetween align-item-center">
            <!-- <input 
            type="time" 
            name="startTime" 
            [value]="givenStartTimeAt24"
            (input)="onTimeChange($event)"
            />
            <span class="color-181F33 fs-14">To</span>
            <input 
            type="time" 
            name="endTime"
            [value]="givenEndTimeAt24"
            (input)="onTimeChange($event)"
            /> -->
            <app-time-picker          
            [formControl]="tempTimeRange.get('startTime')" 
            (changeCallback)="handleTimeRangeChange($event)"
            >
            </app-time-picker>
            <span class="color-181F33 fs-14">To</span>
            <app-time-picker          
            [formControl]="tempTimeRange.get('endTime')" 
            (changeCallback)="handleTimeRangeChange($event)"
            >
            </app-time-picker>


            <!-- <mis-timerangepicker
            [givenStartTime]="givenStartTimeUnix"
            [givenEndTime]="givenEndTimeUnix"
            (timeRangeEmitter)="handleTimeRangeChange($event)"
            ></mis-timerangepicker> -->
        </div>
        <div class="displayFlexSpaceBetween align-item-center mt-12">
            <span *ngIf="!isRangeValid || !isEnteredTimeValid" class="error-text displayFlexSpaceBetween align-item-center">
                <img src="assets/error-16.svg" alt="error-icon">
                Invalid Time {{!isEnteredTimeValid ? 'Format': !isRangeValid ? 'Range' : ''}}!
            </span>
            <button [ngClass]="{'btn-disabled': !isRangeValid || !this.tempTimeRange.valid || !isEnteredTimeValid}" (click)="setTimeRange()" class="apply-btn displayFlexCenter align-item-center fs-14 font-weight-700">
                Apply
            </button>
        </div>
    </div>
    </ng-template>
</div>